import { Box, Divider, IconButton, Typography } from '@mui/material';
import Icon from '@src/main/ui/components/common/Icon/Icon';
import ListItem from '@src/main/ui/components/common/List/ListItem/ListItem';
import { FC } from 'react';
import styles from './AdminAddDashboardsListItem.module.scss';

interface Props {
  item: { id: string; name: string };
  actions: {
    add: boolean;
    edit: boolean;
    delete: boolean;
  };
  onClickEdit: (modal: { open: boolean; name: string; id: string }) => void;
  onClickDelete: (modal: { open: boolean; name: string; id: string }) => void;
  onClick: () => void;
}

const AdminAddDashboardsListItem: FC<Props> = ({
  item,
  actions,
  onClickEdit,
  onClickDelete,
  onClick,
}) => (
  <>
    <ListItem key={item.id} onClick={onClick}>
      <Box className={styles.container__item}>
        <Typography>{item.name}</Typography>
        <Box className={styles.container__item__actions}>
          {actions.edit && (
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                onClickEdit({
                  open: true,
                  name: item.name,
                  id: item.id,
                });
              }}
            >
              <Icon iconId="edit" />
            </IconButton>
          )}
          {actions.delete && (
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                onClickDelete({
                  open: true,
                  name: item.name,
                  id: item.id,
                });
              }}
            >
              <Icon iconId="delete" />
            </IconButton>
          )}
        </Box>
      </Box>
    </ListItem>
    <Divider />
  </>
);
export default AdminAddDashboardsListItem;
